exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3qWkD{background-color:-wix-colors-backgroundColor;box-sizing:border-box}", ""]);

// exports
exports.locals = {
	"container": "_3qWkD"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/mobile/layouts/home/home.styl
// module id = 2820
// module chunks = mobile/mobile